import React from "react";
import Layout from "./Layout";
import SancionesSection from "../sections/SancionesSection";

const Sanciones = () => {
  return (
    <>
      <Layout>
        <SancionesSection />
      </Layout>
    </>
  );
};

export default Sanciones;
